var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items && _vm.items.length)?_c('div',{staticClass:"trends-col"},[_c('div',{staticClass:"trends-col__list"},_vm._l((_vm.items),function(item,i){return _c('div',{key:i,staticClass:"trends-col__item"},[_c('SlideComponent',{attrs:{"trend":true,"data":item}})],1)}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }